"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Swarmed_OnTurnStartedEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EffectType_1 = require("../../core/effects/EffectType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
let Effect_Swarmed_OnTurnStartedEventHandlerScript = class Effect_Swarmed_OnTurnStartedEventHandlerScript {
    run(sequence, container, handler, event) {
        const roll = (0, Random_1.random)(1, 100);
        if (roll <= 25) {
            if (container.hasEffectOfType(event.subject, EffectType_1.EffectType.Stun)) {
                return;
            }
            container.applyDebuff({
                sequence,
                attackerId: handler.args.scriptArgs.appliedBy,
                duration: Duration_1.Duration.Turns(1),
                targetId: event.subject,
                effect: new core_1.StunEffectArgs(),
            });
        }
        else if (roll <= 25) {
            const canSpreadTo = container.selectLivingTargets(event.subject, Target_1.Target.AllAllies)
                .filter(ally => !container.hasEffectOfType(ally, EffectType_1.EffectType.Swarmed));
            if (canSpreadTo.length === 0) {
                return;
            }
            const targetId = (0, Random_1.randomElement)(canSpreadTo);
            container.applyDebuff({
                sequence,
                attackerId: handler.args.scriptArgs.appliedBy,
                duration: Duration_1.Duration.Permanent,
                targetId,
                effect: new core_1.SwarmedEffectArgs(),
            });
        }
    }
};
Effect_Swarmed_OnTurnStartedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Swarmed_OnTurnStarted")
], Effect_Swarmed_OnTurnStartedEventHandlerScript);
exports.Effect_Swarmed_OnTurnStartedEventHandlerScript = Effect_Swarmed_OnTurnStartedEventHandlerScript;
